import { JsonConverter, JsonCustomConvert, JsonConvert, JsonObject, JsonProperty, Any } from "json2typescript";
import { BaseResponse } from "../base-response";

@JsonConverter
export class GodCreateConverter implements JsonCustomConvert<GodCreate>{
    serialize() { }
    deserialize(data: any): GodCreate {
        const jsonConvert: JsonConvert = new JsonConvert();
        return jsonConvert.deserializeObject(data, GodCreate);
    }
}

@JsonConverter
export class GodCreateArrayConverter implements JsonCustomConvert<Array<GodCreate>>{
    serialize() { }
    deserialize(data: any):Array<GodCreate> {
        const jsonConvert: JsonConvert = new JsonConvert();
        return jsonConvert.deserializeArray(data, GodCreate);
    }
}

@JsonObject("GodCreate")
export class GodCreate{
    @JsonProperty("id", String, true)
    id: string = "";
    @JsonProperty("username", String, true)
    username: string = "";
    @JsonProperty("password", String, true)
    password: string = "";
    @JsonProperty("metadata", Any, true)
    metadata: any = null;

    dto(isEdit: boolean = false) {
        const baseDto: any = {
            username: this.username,
            metadata: this.metadata,
        };

        if (!isEdit || (isEdit && this.password)) {
            baseDto.password = this.password;
        }

        return baseDto;
    }
}

@JsonObject("GodCreateData")
export class GodCreateData extends BaseResponse {
    @JsonProperty("data", GodCreateConverter, true)
    data: GodCreate = new GodCreate;
}

@JsonObject("GodCreateDataAll")
export class GodCreateDataAll extends BaseResponse {
    @JsonProperty("data", GodCreateArrayConverter, true)
    data: Array<GodCreate> = new Array<GodCreate>();
}

@JsonObject("GodCreateListCount")
export class GodCreateListCount {
    @JsonProperty("count", Number, true)
    count: number = 0;
    @JsonProperty("data", GodCreateArrayConverter, true)
    data: Array<GodCreate> = new Array<GodCreate>();
}
@JsonObject("GodCreateListData")
export class GodCreateListData extends BaseResponse {
    @JsonProperty("data", GodCreateListCount, true)
    data: GodCreateListCount = new GodCreateListCount;
}